import axios from 'axios';
import { URL_DIALOG_FLOW } from '../../constants';

/**
 * Function Request ChatBot
 * @param {string} inputMessage
 */
export async function requestBot(
  token,
  sessionId,
  type,
  inputMessage,
  parameters
) {
  const body = JSON.stringify({
    query: inputMessage,
    type,
    sessionId,
    parameters,
  });

  try {
    const request = await axios.post(`${URL_DIALOG_FLOW}`, body, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${token}`,
      },
    });

    const messages = [];

    if (request.data[0].queryResult.webhookPayload) {
      messages.push({
        id: 7,
        suggestedActions:
          request.data[0].queryResult.webhookPayload.fields.carousel.listValue.values.map(
            (element) => ({
              type: 'carousel',
              title: element.structValue.fields.title.stringValue,
              description: element.structValue.fields.description.stringValue,
              value: element.structValue.fields.title.stringValue,
              img: element.structValue.fields.image.stringValue,
              button: element.structValue.fields.button.structValue.fields.text,
              redirect_uri:
                element.structValue.fields.button.structValue.fields.url,
            })
          ),
      });
    }

    // eslint-disable-next-line consistent-return
    request.data[0].queryResult.fulfillmentMessages.forEach((element) => {
      /** PLATFORM UNSPECIFIED */
      if (element.platform === 'PLATFORM_UNSPECIFIED') {
        /** DEFAULT DIALOGFLOW */
        if (element.message === 'text') {
          return messages.push({
            id: 2,
            message: element.text.text,
          });
        }

        /** CARD SUBSCRIPTION BACKEND */
        if (element.message === 'card') {
          return messages.push({
            id: 8,
            suggestedActions: [
              {
                type: 'card',
                title: element.card.title,
                subtitle: element.card.subtitle,
                image: element.card.imageUri,
                button: element.card.buttons[0].text,
                redirect_uri: element.card.buttons[0].postback,
              },
            ],
          });
        }
      }

      /** PLATFORM GOOGLE */
      if (element.platform === 'ACTIONS_ON_GOOGLE') {
        if (element.message === 'suggestions') {
          return messages.push({
            id: 3,
            suggestedActions: element.suggestions.suggestions.map((x) => ({
              type: 'buttons',
              title: x.title,
              value: x.title,
            })),
          });
        }

        if (element.message === 'listSelect') {
          return messages.push({
            id: 6,
            suggestedActions: element.listSelect.items.map((x) => ({
              type: 'list',
              title: x.title,
              value: x.title,
            })),
          });
        }

        if (element.message === 'carouselSelect') {
          return messages.push({
            id: 7,
            suggestedActions: element.carouselSelect.items.map((x) => ({
              type: 'carousel',
              title: x.title,
              description: x.description,
              value: x.title,
              img: x.image.imageUri,
              event: x.info.key,
            })),
          });
        }

        if (element.message === 'linkOutSuggestion') {
          if (element.linkOutSuggestion.uri.indexOf('youtube') > -1) {
            return messages.push({
              id: 4,
              suggestedActions: [
                {
                  type: 'video',
                  title: element.linkOutSuggestion.destinationName,
                  value: element.linkOutSuggestion.uri,
                },
              ],
            });
          }

          return messages.push({
            id: 5,
            suggestedActions: [
              {
                type: 'chat',
                title: element.linkOutSuggestion.destinationName,
                value: element.linkOutSuggestion.uri,
              },
            ],
          });
        }
      }
    });

    messages.sort((a, b) => {
      if (a.id < b.id) return -1;
      if (a.id > b.id) return 1;
      return 0;
    });

    return { status: true, messages };
  } catch (error) {
    if (error.response) {
      return { status: false, message: `Ops, ocorreu um erro.` };
    }

    if (error.request) {
      return { status: false, message: `Ops, ocorreu um erro.` };
    }

    return { status: false, message: `Ops, ocorreu um erro.` };
  }
}
